// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M23 3H1V14H23V3Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M23 16H1V19H11V20H7V22H17V20H13V19H23V16Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-desktop-1-filled')
export default class Desktop1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'desktop-1-filled',
    }
  }
}
